var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css, keyframes } from '@emotion/core';
import { variables as vars } from '@domain-group/fe-brary';
var colour = vars.colour,
  global = vars.global;
var slideUp = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(100%);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n"])));
export var stickyFooter = /*#__PURE__*/css("animation:", slideUp, " 0.5s ease-in;position:fixed;bottom:0;width:100%;z-index:", global.layerFloating, ";background:", colour.white, ";transform:translate3d(0,0,0);display:none;> *{transform:translate3d(0,0,0);}");
export var visible = {
  name: "13o7eu2",
  styles: "display:block;"
};